export default __webpack_public_path__ + "static/bundle3-3212a3c33cdae97c9f20ca9eae929fd4.png";